// React's view of the account session (lib/account.ts holds the store).

import { useSyncExternalStore } from "react";
import { getSession, subscribeSession, type AccountSession } from "@web-shared/lib/account";

/** The signed-in session, or null — re-renders on sign in, sign out, refresh. */
export function useSession(): AccountSession | null {
  return useSyncExternalStore(subscribeSession, getSession, () => null);
}
